<template>
  <div class="call-center-info-list container">
    <breadcrumb crumb="call-center-task" />
    <search-block @search="onSearch" />
    <el-table
      v-if="loading || !list.length"
      v-loading="loading"
      :data="list"
      style="width: 100%; height: 40vh"
    />
    <el-collapse-transition>
      <section v-if="list.length && !loading" class="container">
        <list-titles :titles="titles">
          <el-checkbox
            v-model="checkAll"
            :indeterminate="indeterminate"
            @change="onCheckAll"
          />
        </list-titles>
        <el-checkbox-group v-model="checked" @change="onCheckOne">
          <cci-item v-for="i in list" :key="i.id" :item="i" @set="setModal" />
        </el-checkbox-group>
        <div class="pagination bottom-section">
          <pagination :data="pagination" @changed="changePage" />
        </div>
      </section>
    </el-collapse-transition>
    <calling-modal
      contact
      :visible="callModal"
      :info="info"
      @close="setModal('callModal')"
    />
    <stats-modal
      :visible="statsModal"
      :calls="calls"
      @close="setModal('statsModal')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { titlesContacts } from '@/views/CallCenter/constants'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import CallingModal from '@/components/Modals/CallingModal'
import CciItem from './components/CCIItem'
import ListTitles from '@/components/Tables/ListTitles'
import Pagination from '@/components/Tables/PaginationCustom'
import SearchBlock from './components/SearchBlock'
import StatsModal from './components/Modals/StatsModal'

export default {
  name: 'Task',
  components: {
    Breadcrumb,
    CciItem,
    Pagination,
    SearchBlock,
    CallingModal,
    StatsModal,
    ListTitles,
  },
  data() {
    return {
      s: '',
      id: 0,
      page: 1,
      checked: [],
      checkAll: false,
      indeterminate: false,
      titles: titlesContacts,
      statsModal: false,
      callModal: false,
    }
  },
  created() {
    this.fetchList()

    if (!this.admins.length) {
      this.fetchAdmins()
    }
  },
  computed: {
    ...mapGetters({
      getList: 'callCenter/getList',
      getPagination: 'callCenter/getPagination',
      getLoading: 'callCenter/getLoading',
    }),
    list() {
      return this.getList('contacts')
    },
    admins() {
      return this.getList('admins')
    },
    loading() {
      return this.getLoading('Cont')
    },
    pagination() {
      return this.getPagination('Cont')
    },
    calls() {
      const contact = this.list.find(l => l.id === this.id)

      return contact ? contact.calls : []
    },
    info() {
      return { user_id: this.userInfo.id, contact_id: this.id }
    },
  },
  methods: {
    ...mapActions({
      fetchContacts: 'callCenter/fetchContacts',
      fetchAdmins: 'callCenter/fetchAdmins',
    }),
    fetchList() {
      const { s, page } = this

      this.fetchContacts({ s, page })
    },
    onSearch(search = '') {
      this.s = search
      this.fetchList()
    },
    changePage(page = 1) {
      this.page = page
      this.fetchList()
    },
    onCheckAll(val) {
      this.checked = val ? this.list.map(f => f.id) : []
      this.indeterminate = false
    },
    onCheckOne(val) {
      const checkedCount = val.length

      this.checkAll = checkedCount === this.list.length
      this.indeterminate = checkedCount > 0 && checkedCount < this.list.length
    },
    setModal(key, id) {
      this[key] = Boolean(id)

      if (id) {
        this.id = id
      }
    },
  },
}
</script>

<style lang="sass">
.call-center-info-list
  font-size: 14px
  color: #000
</style>
